// Entry point for public pages.
// This is used on a public page indexed by Google, please try to keep JS to a minimum.
// See react_components.js for documentation.

import LockedModal from 'components/authentication_modals/LockedModal'
import Page from 'components/supplier_search/Page'
import Search from 'components/supplier_onboarding/search'
import SignInModal from 'components/authentication_modals/SignInModal'
import SignUpModal from 'components/authentication_modals/SignUpModal'
import UnauthedSupplierSearch from 'components/search/UnauthedSupplierSearch'
import { mount } from 'packs/config/react_rails'

const components = {
  'authentication_modals/LockedModal': LockedModal,
  'authentication_modals/SignInModal': SignInModal,
  'authentication_modals/SignUpModal': SignUpModal,
  'search/UnauthedSupplierSearch': UnauthedSupplierSearch,
  'supplier_onboarding/search': Search,
  'supplier_search/Page': Page
}

mount(components)
